import RecallService from '@services/recall.service';
const recallService = RecallService.getInstance();

const ZOOM_CLIENT_ID = import.meta.env.VITE_ZOOM_CLIENT_ID;
const ZOOM_REDIRECT_URI = import.meta.env.VITE_ZOOM_REDIRECT_URI;

const ZOOM_USER_CLIENT_ID = import.meta.env.VITE_ZOOM_USER_CLIENT_ID;
const ZOOM_USER_REDIRECT_URI = import.meta.env.VITE_ZOOM_USER_REDIRECT_URI;

export async function connectZoomAccount(account = true) {
  const params = {
    response_type: 'code',
    redirect_uri: account ? ZOOM_REDIRECT_URI : ZOOM_USER_REDIRECT_URI,
    client_id: account ? ZOOM_CLIENT_ID : ZOOM_USER_CLIENT_ID,
    account
  };

  const queryString = new URLSearchParams(params).toString();
  window.location.assign(`https://zoom.us/oauth/authorize?${queryString}`);
}

export async function registerWithBackend(code) {
  return recallService.createZoomOAuthCredential(code, ZOOM_REDIRECT_URI);
}
